<template>
    <div id="app">
        <chat-window></chat-window>
        <chat-button></chat-button>
    </div>
</template>

<script>
import ChatButton from './components/ChatButton.vue'
import ChatWindow from './components/ChatWindow.vue'
import store from './store';
import Vue from 'vue'
import VueConfirmDialog from 'vue-confirm-dialog'

Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)


import GetTextPlugin from "vue-gettext";
import translations from './translations/translations.json'

Vue.directive('prevent-parent-scroll', {
    bind(el) {
        const handler = (event) => {
            if (el.scrollTop === 0  && event.deltaY < 0 ||
                Math.abs(el.scrollTop - (el.scrollHeight - el.clientHeight)) <= 1 &&
                event.deltaY > 0)
            {
                event.preventDefault()
            }
        }
        el.addEventListener('wheel', handler)
    }
})


Vue.config.productionTip = false
Vue.use(GetTextPlugin, {
    availableLanguages: {
        en: 'English',
        es: 'Spanish'
    },
    defaultLanguage: 'es',
    languageVmMixin: {
        methods: {
            merge(locale) {
                Object.assign(translations, locale);
            },
        }
    },
    translations: translations,
    silent: true
})


import {mapState, mapMutations} from 'vuex';

export default {
    store,
    name: 'App',
    props: {
        groups: {
            type: String,
            default: '7,8,10,11,12'
        },
        policy_url: {
            type: String,
            default: '/'
        }
    },
    components: {
        ChatButton,
        ChatWindow
    },
    mounted: function () {

        store.commit('setPolicyUrl', this.policy_url);
        store.commit('setLocale', document.documentElement.lang);
        if(this.isChatOpened){
            store.http.getChatGroups(this.groups);
        }
        store.http.startThreadRefresh();
        store.websiteService.getUserInfo();
        store.websiteService.getCartInfo();
        if (!this.has_bounced){
            this.toggleBounce();
        }

    },
    created: function () {
        const linkNode = document.createElement('link');
        linkNode.type = 'text/css';
        linkNode.rel = 'stylesheet';
        linkNode.href = 'https://static.islas.ikea.es/assets/modules/pws/fonts/fonts.css?v=3';
        //linkNode.href = 'https://pasapaginas1.s3-website-eu-west-1.amazonaws.com/modules/pws/fonts/fonts.css?v=4';
        document.head.appendChild(linkNode);
    },
    watch: {
        isChatOpened: function (value) {
            if (value) {
                store.http.getChatGroups(this.groups);
            }
        },
        hasNewMessages: function (value) {
            if (value && !this.isChatOpened) {
                this.toggleBounce(true);
            }
        }
    },
    methods: {
      ...mapMutations(['changeBounce', "changeHasBounced"]),
        toggleBounce: function (withoutDelay) {
            this.changeHasBounced(true);
            var start_timeout = 5000;
            if (withoutDelay){
                start_timeout = 0;
            }
            setTimeout(() => {
              this.changeBounce(true);
                setTimeout(() => {
                    this.changeBounce(false);
                }, 10000);
            }, start_timeout);
        }
    },
    computed:{
      ...mapState(['bounce', "hasNewMessages", "isChatOpened", "hasBounced"])
    }
}
</script>

<style lang="css">
/* the vue-confirm css is not being applied to the shadow root. */
.vc-overlay *, .vc-overlay :after, .vc-overlay :before {
    box-sizing: border-box;
    text-decoration: none;
    -webkit-touch-callout: none;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0
}

.vc-title {
    color: var(--title-color);
    font-weight: var(--font-weight-black);
    font-size: var(--font-size-m);
    margin-bottom: 5px
}

.vc-text, .vc-title {
    padding: 0 1rem;
    width: 100%;
    text-align: center;
    line-height: normal;
    box-sizing: border-box;
}

.vc-text {
    color: var(--message-color);
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-s)
}

.vc-overlay {
    background-color: var(--overlay-background-color);
    width: 100%;
    height: 100%;
    transition: all .1s ease-in;
    left: 0;
    top: 0;
    z-index: 999999999999;
    position: fixed;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-line-pack: baseline;
    align-content: baseline
}

.vc-container {
    background-color: var(--base-background-color);
    border-radius: 1rem;
    width: 286px;
    height: auto;
    display: grid;
    grid-template-rows:1fr -webkit-max-content;
    grid-template-rows:1fr max-content;
    box-shadow: var(--container-box-shadow)
}

.vc-text-grid {
    padding: 1rem
}

.vc-btn-grid {
    width: 100%;
    display: grid;
    grid-template-columns:1fr 1fr;
    border-radius: 0 0 1rem 1rem;
    overflow: hidden
}

.vc-btn-grid.isMono {
    grid-template-columns:1fr
}

.vc-btn {
    border-radius: 0 0 1rem 0;
    color: var(--button-color);
    background-color: var(--button-background-color);
    border: 0;
    font-size: 1rem;
    border-top: 1px solid var(--button-border-color);
    cursor: pointer;
    font-weight: var(--font-weight-bold);
    outline: none;
    min-height: 50px
}

.vc-btn:hover {
    background-color: var(--button-background-color-hover)
}

.vc-btn:disabled {
    background-color: var(--button-background-color-disabled)
}

.vc-btn:active {
    box-shadow: var(--button-box-shadow-active)
}

.vc-btn.left {
    border-radius: 0;
    border-right: 1px solid var(--button-border-color)
}

.vc-input[type=password] {
    width: 100%;
    outline: none;
    border-radius: 8px;
    height: 35px;
    border: 0;
    margin: 5px 0;
    background-color: var(--input-background-color);
    padding: 0 .5rem;
    font-size: var(--font-size-m);
    transition: .21s ease
}

.vc-input[type=password]:focus, .vc-input[type=password]:hover {
    background-color: var(--input-background-color-hover)
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .21s
}

.fade-enter, .fade-leave-to {
    opacity: 0
}

.zoom-enter-active, .zoom-leave-active {
    animation-duration: .21s;
    animation-fill-mode: both;
    animation-name: zoom
}

.zoom-leave-active {
    animation-direction: reverse
}

@keyframes zoom {
    0% {
        opacity: 0;
        transform: scale3d(1.1, 1.1, 1.1)
    }
    to {
        opacity: 1;
        transform: scaleX(1)
    }
}
</style>

<style lang="scss">
@import "./assets/fonts/fonts_local.css";
@import "./assets/css/pws-icons.css";
@import './assets/scss/pws.scss';
</style>
